import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id EF5AA157-F8E2-47FB-9A9C-8ACC66A9C2FB
 * name middleware
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/middleware.svg
 * tags
 * - Arrow 
 */
export const MiddlewareIcon = createSvgIcon(<><path d="M23 12L19 8V11H14.82C14.4 9.84 13.3 9 12 9S9.6 9.84 9.18 11H5L2 8V16L5 13H9.18C9.6 14.16 10.7 15 12 15S14.4 14.16 14.82 13H19V16L23 12Z" /></>, 'MiddlewareIcon');
export default MiddlewareIcon